import type { Component } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

import { notLoggedGuard } from 'src/logic/guards/not-logged.guard';
import { alreadyLoggedGuard } from 'src/logic/guards/already-logged.guard';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: (): Component => import('src/pages/(app)/app.vue'),
      beforeEnter: notLoggedGuard,
      children: [
        {
          path: 'settings',
          name: 'settings',
          component: (): Component => import('src/pages/(app)/components/settings/settings.vue'),
        },
        {
          path: '',
          name: 'home',
          component: (): Component => import('src/pages/(app)/components/home/home.vue'),
        },
        {
          path: 'clients',
          name: 'clients',
          component: (): Component =>
            import('src/pages/(app)/components/clients-list/clients-list.vue'),
        },
        {
          path: 'clients/:miniatureClientId',
          name: 'client-miniature',
          component: (): Component =>
            import('src/pages/(app)/components/clients-list/client-modal-miniature/client-modal-miniature.vue'),
        },
        {
          path: 'search/:id',
          name: 'search',
          component: (): Component =>
            import('src/pages/(app)/components/clients-list/search-by-params/search-by-params.vue'),
        },
        {
          path: 'client-details/:id',
          name: 'client-details',
          component: (): Component =>
            import('src/pages/(app)/components/clients-list/client-details/client-details.vue'),
        },
        {
          path: 'accounts/:id',
          name: 'another-persons-account',
          component: (): Component => import('src/pages/(app)/components/home/home.vue'),
        },

        {
          path: 'objects',
          name: 'objects',
          component: (): Component =>
            import('src/pages/(app)/components/objects-list/objects-list.vue'),
        },
        {
          path: 'objects/:id',
          name: 'object-details',
          component: (): Component =>
            import('src/pages/(app)/components/objects-list/object-details/object-details.vue'),
        },

        {
          path: 'presets',
          name: 'presets',
          component: (): Component =>
            import('src/pages/(app)/components/user-presets-page/user-presets-page.vue'),
        },

        {
          path: 'countries',
          name: 'countries',
          component: (): Component => import('src/pages/(app)/components/countries/countries.vue'),
        },
        {
          path: 'faq',
          name: 'faq',
          component: (): Component => import('src/pages/(app)/components/faq/faq.vue'),
        },
        {
          path: 'closed-deals',
          name: 'closed-deals',
          component: (): Component =>
            import('src/pages/(app)/components/closed-deals/closed-deals.vue'),
        },
        {
          path: 'support',
          name: 'support',
          component: (): Component => import('src/pages/(app)/components/support/support.vue'),
        },
        {
          path: 'documents',
          name: 'documents',
          component: (): Component =>
            import('src/pages/(app)/components/documents-list/documents-list.vue'),
        },
        {
          path: 'ai-assistant',
          name: 'ai-assistant',
          component: (): Component =>
            import('src/pages/(app)/components/ai-assistant/ai-assistant.vue'),
        },
        // Временно скрыто, компотент страхования
        // {
        //   path: 'insurance',
        //   name: 'insurance',
        //   component: (): Component =>
        //     import('src/pages/(app)/components/insurance/insurance.vue'),
        // },
        {
          path: 'chat',
          name: 'chat',
          component: (): Component => import('src/pages/(app)/components/chat/chat-list.vue'),
        },
        {
          path: 'dialogue/:id/:clientId/:chatId',
          name: 'dialogue',
          component: (): Component =>
            import('src/pages/(app)/components/chat/dialogue/dialogue.vue'),
        },
      ],
    },
    {
      path: '/',
      component: (): Component => import('src/pages/(auth)/auth.vue'),
      beforeEnter: alreadyLoggedGuard,
      children: [
        {
          path: '/sign-in',
          name: 'signIn',
          component: (): Component => import('src/pages/(auth)/components/login/login.vue'),
        },
        {
          path: '/sign-up',
          name: 'signUp',
          component: (): Component => import('src/pages/(auth)/components/register/register.vue'),
        },
        {
          path: '/recover',
          name: 'recover',
          component: (): Component =>
            import('src/pages/(auth)/components/recover-password/recover-password.vue'),
        },
      ],
    },
    {
      path: '/',
      component: (): Component => import('src/pages/(onboarding)/onboarding.vue'),
      beforeEnter: notLoggedGuard,
      children: [
        {
          path: 'onboarding',
          name: 'onboarding',
          component: (): Component =>
            import('src/pages/(onboarding)/components/competencies/competencies.vue'),
        },
      ],
    },
    {
      path: '/documents/:slug',
      component: (): Component =>
        import('src/pages/(public)/components/document-download/document-download.vue'),
    },
    {
      path: '/:catchAll(.*)',
      name: '404',
      component: (): Component => import('src/pages/(not-found)/not-found.vue'),
    },
  ],
  linkExactActiveClass: 'router-link-exact-active',
});

export default router;
